import React from "react";
import PreviousIcon from "../PreviousIcon/index.jsx";
import NextIcon from "../NextIcon/index.jsx";

const PlayerControls = ({
  onPrevClick,
  onNextClick,
  pos,
  duration,
  currentTime
}) => {
  return (
    <div className="player-controls">
      <div className="timestamp">
        <span>
          {currentTime} / {duration}
        </span>
      </div>
      <button onClick={onPrevClick}>
        <PreviousIcon />
      </button>
      <button onClick={onNextClick}>
        <NextIcon />
      </button>
    </div>
  );
};

export default PlayerControls;
